<template>
	<div id="StepWizardContact" class="text-left">
		<div v-if="showMediaManager" class="media--manager">
      		<div class="nav-mediaManager p-4">
        		<i class="fas fa-chevron-down" @click="showMediaManager = false"></i>
      		</div>
      		<MediaManager 
				@receiveMedias="addPictures($event)"
				@closeTabs="closeTabs()"
			 />
		</div>
		<div class="title-area">
      		<h4>{{stepName}}</h4>
      		<p>Escolha uma imagem para ficar na sua página de contato</p>
    	</div>
    	<div class="input-area">
      		<div class="card p-2 my-2">
        		<div class="row">
          			<div class="col-auto my-2" @click="showMediaManager = true">
            			<img class="img-fluid" src="../../assets/img/icons/add_media@2x.png" alt />
					</div>
					<div
						class="col-auto text-center my-2 card--image"
						v-for="(picture, index) in contactPictures"
						:key="index"
					>
						<BaseImage :source="picture" :customClass="'img-fluid'" />
						<span class="span-close">
							<i class="fas fa-times-circle" @click="removeImage(index)"></i>
						</span>
					</div>
				</div>
			</div>
			<ul class="options--contact">
				<li @click="contactData.showWhatsapp = !contactData.showWhatsapp">
					<span :class="[contactData.showWhatsapp ? 'active' : '']">
						<i class="fas fa-check-circle"></i>
					</span> Ativar chat Whatsapp
				</li>
				<li @click="contactData.showMap = !contactData.showMap">
					<span :class="[contactData.showMap ? 'active' : '']">
						<i class="fas fa-check-circle"></i>
					</span> Exibir mapa
				</li>
				<li @click="contactData.showTelephone = !contactData.showTelephone">
					<span :class="[contactData.showTelephone ? 'active' : '']">
						<i class="fas fa-check-circle"></i>
					</span> Exibir telefone
				</li>
			</ul>
    	</div>
  	</div>
</template>

<script>
import MediaManager from "@/components/organisms/MediaManager";
import BaseImage from "@/components/atoms/BaseImage";
export default {
	name: "StepWizardContact",
	data() {
		return {
			showMediaManager: false,
			contactData: {}
		};
	},
	props: {
		stepName: {
			type: String,
			required: false
		}
	},
	methods: {
		addPictures(content) {
					let pictures = []
					content.forEach(element => {
						pictures.push(element.url)
					});
			this.$store.dispatch("CONTACT_ADD_PICTURE", [pictures]);
			this.showMediaManager = false;
		},
		updateContact() {
			this.$store.dispatch("UPDATE_CONTACT", [this.contactData]);
		},
		removeImage(index) {
			this.$store.dispatch("CONTACT_REMOVE_PICTURE", [index]);
		},
		closeTabs() {
			this.showMediaManager = false;
		}
  	},
  	components: {
		MediaManager,
    	BaseImage
  	},
  	created() {
    	this.contactData = this.$store.state.wizard.dataSite.contactSetup;
  	},
  	computed: {
    	contactPictures() {
      		return this.$store.state.wizard.dataSite.contactSetup.images;
    	}
  	},
  	mounted() {
		this.$emit("updateStep");
    	this.$store.dispatch("WIZARD_SHOW_SKIP", [true]);
    	this.$store.dispatch("WIZARD_BLOCK_NEXT", [false]);
  	}
};
</script>

<style>
.card--image img {
	height: 80px;
  	object-fit: cover;
}
.options--contact {
  	margin-top: 30px;
  	padding: 0;
  	border-top: 1px solid rgba(112, 112, 112, 0.12);
}
.options--contact li {
  	list-style: none;
  	border-bottom: 1px solid rgba(112, 112, 112, 0.12);
  	padding: 15px 0;
  	cursor: pointer;
}
.options--contact li span {
  	color: #ebebeb;
  	margin-right: 20px;
}
.options--contact li span.active {
  	color: var(--main-color);
}
.span-close {
  	position: absolute;
  	right: 18px;
  	top: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/StepWizardContact.vue